var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMdiTwitter = function SvgMdiTwitter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.718 5a7.14 7.14 0 0 1-2.05.575 3.582 3.582 0 0 0 1.567-1.984 7.202 7.202 0 0 1-2.266.875c-.659-.716-1.584-1.133-2.634-1.133a3.57 3.57 0 0 0-3.558 3.575c0 .283.033.558.091.817A10.162 10.162 0 0 1 2.502 3.99a3.537 3.537 0 0 0-.484 1.792c0 1.242.625 2.342 1.592 2.967a3.536 3.536 0 0 1-1.625-.417v.025a3.578 3.578 0 0 0 2.867 3.508 3.517 3.517 0 0 1-1.609.059 3.566 3.566 0 0 0 3.334 2.483 7.1 7.1 0 0 1-4.442 1.533c-.283 0-.567-.016-.85-.05A10.12 10.12 0 0 0 6.768 17.5c6.567 0 10.175-5.45 10.175-10.175 0-.159 0-.309-.008-.467.7-.5 1.3-1.133 1.784-1.858Z",
    fill: "#323232"
  })));
};
export default SvgMdiTwitter;